'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _RelayRouter2 = require('./RelayRouter');

var _RelayRouter3 = _interopRequireDefault(_RelayRouter2);

exports.RelayRouter = _RelayRouter3['default'];

var _RelayRouterContext2 = require('./RelayRouterContext');

var _RelayRouterContext3 = _interopRequireDefault(_RelayRouterContext2);

exports.RelayRouterContext = _RelayRouterContext3['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-relay/lib/index.js
 ** module id = 596
 ** module chunks = 0
 **/